module.exports = global["$"] = require("-!E:\\dev\\repos\\wpo_sitecontrol\\node_modules\\expose-loader\\index.js?jQuery!E:\\dev\\repos\\wpo_sitecontrol\\node_modules\\jquery\\dist\\jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/expose-loader?$!./~/expose-loader?jQuery!./~/jquery/dist/jquery.js
// module id = 167
// module chunks = 1